import { render, staticRenderFns } from "./TextAreaField.vue?vue&type=template&id=021ae311&scoped=true&"
import script from "./TextAreaField.vue?vue&type=script&lang=js&"
export * from "./TextAreaField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021ae311",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nicholashaskell/Local/kicknic/app/public/wp-content/themes/kicknic/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('021ae311')) {
      api.createRecord('021ae311', component.options)
    } else {
      api.reload('021ae311', component.options)
    }
    module.hot.accept("./TextAreaField.vue?vue&type=template&id=021ae311&scoped=true&", function () {
      api.rerender('021ae311', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/scripts/components/panels/form/TextAreaField.vue"
export default component.exports